import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MyTextarea = ({ label, ...props }) => {
  const [field] = useField(props)
  return (
    <div className={`${props.areaclass}`}>
      <label
        className="block text-sm font-medium text-gray-700"
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <textarea
        className={
          'mt-1 block h-auto w-full resize-none rounded-md border border-gray-300 shadow-sm ' +
          'focus:border-gray-500 focus:ring-gray-500 sm:text-sm'
        }
        rows={props.row}
        {...field}
        {...props}
      />
    </div>
  )
}
export default MyTextarea

MyTextarea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  areaclass: PropTypes.string,
  row: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  name: PropTypes.string,
}
